import { MortgagePayoffCalculator } from "../Apps/MortgagePayoffCalculator"

function AppMortgagePayoffCalculator() {

  return (
    <MortgagePayoffCalculator />
  )
}

export default AppMortgagePayoffCalculator

